import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export const ComingSoon = ({ title, description }) => {
  useDocumentTitle(title);
  return (
    <section className="container-wide py-32" data-testid="coming-soon-page">
      <div className="max-w-2xl">
        <div className="font-accent text-[10px] mb-6" style={{ color: "var(--gi-gold)" }}>This page is being prepared</div>
        <h1 className="font-heading text-5xl sm:text-6xl leading-[1.05]" style={{ color: "var(--gi-maroon)" }} data-testid="coming-soon-title">
          {title}
        </h1>
        <div className="hair-divider my-10" />
        <p className="text-lg leading-relaxed" style={{ color: "var(--gi-charcoal-2)" }} data-testid="coming-soon-description">
          {description}
        </p>
        <div className="mt-12 flex flex-wrap gap-4">
          <Link to="/books" className="btn-maroon" data-testid="coming-soon-books-btn">Explore the Books <ArrowRight size={14} /></Link>
          <Link to="/join-the-movement" className="btn-outline" data-testid="coming-soon-join-btn">Join the Mission</Link>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
